module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("WHO DO YOU THINK YOU ARE?")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#con1",
      "id": "toc1"
    }
  }, [_vm._v("1"), _c('br'), _c('br'), _vm._v(" I AM __________?")])]), _vm._v(" "), _c('p', {
    staticClass: "exts"
  }, [_c('span', [_vm._v("You see, I have this condition.")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("—LEONARD SHELBY IN THE MOVIE "), _c('i', [_vm._v("MEMENTO")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1b",
    attrs: {
      "id": "p0009-03-2"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("n the movie "), _c('i', [_vm._v("Memento")]), _vm._v(", Leonard Shelby tries to track down his wife’s killer. Complicating the search is the fact that as a result of a blow to the head by the murderer, Leonard suffers from anterograde amnesia, a condition that makes it impossible for him to remember anything new for more than a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-5"
    }
  }, [_vm._v("To cope with his amnesia, Leonard creates a complicated system of notes, Polaroid photos, and tattoos to remember facts and string together evidence to find his wife’s killer and exact revenge. Unfortunately, several shady characters try to manipulate Leonard’s condition for their own gain. Using his amnesia against him, they tell him lies about his past, who he is, and their intentions for him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-6"
    }
  }, [_c('i', [_vm._v("Memento")]), _vm._v(" toys with the concepts of "), _c('span', {
    attrs: {
      "id": "page_p0009-02-1_25_identity"
    }
  }, [_vm._v("identity")]), _vm._v(" and "), _c('span', {
    attrs: {
      "id": "page_p0009-02-1_16_truth"
    }
  }, [_vm._v("truth")]), _vm._v(". As the movie progresses, doubt is cast on Leonard’s version of the story, and you begin to wonder if the Leonard the movie portrays is really the true Leonard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-7"
    }
  }, [_vm._v("In one important scene, Teddy, Leonard’s crooked “friend,” says to him, “You don’t know who you are anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0009-04-8"
    }
  }, [_vm._v("“Of course I do,” Leonard responds. “I’m Leonard Shelby. I’m from San Francisco.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("“No, that’s who you "), _c('i', [_vm._v("were")]), _vm._v(",” Teddy says. “Maybe it’s time you started investigating yourself.”")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-01-1"
    }
  }, [_vm._v("What follows is a series of revelations about Leonard that cause him to question the identity he’s built for himself. He then suffers a severe "), _c('span', {
    attrs: {
      "id": "page_p0010-01-0_38_identity"
    }
  }, [_vm._v("identity crisis")]), _vm._v(" that leads to the movie’s shocking ending—all because he can’t remember who he is.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0010-02-3"
    }
  }, [_vm._v("IDENTITY CRISIS")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0010-03-4"
    }
  }, [_vm._v("As Christians, we’re a lot like Leonard. We have a condition. We’re continually forgetting who we are in Christ and filling that void by placing our identity in pretty much anything else. This leads us to often ask, as Leonard did, “Who am I?” The question is far-reaching, belief-revealing, life-shaping, and identity-forming. How you answer determines your identity and your testimony. Tragically, few people—even few Bible-believing, Jesus-loving Christians—rightly answer that question.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-04-6"
    }
  }, [_vm._v("How we see ourselves is our identity. Our culture talks about identity as self-image or self-esteem. As a parent and pastor, I believe that correctly knowing one’s true identity is the one thing that changes everything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-04-7"
    }
  }, [_vm._v("For years, I pastored and counseled people struggling with issues such as alcoholism, sexual perversion, pride, depression, anger, bitterness, and more. Often I felt as though I were talking to a wall because, though I gave biblical counsel, many people seemed to either not hear or not care and instead continued down a path of destruction. It was frustrating and heartbreaking. I felt there had to be a way to help people find freedom.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-04-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Then, thanks in large part to the wise words of older and more seasoned counselors, it dawned on me that underlying our struggles in life is the issue of our identity.")]), _c('span', {
    attrs: {
      "href": "#/chapter19#en1",
      "id": "ne1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-P-1"
    }
  }, [_vm._v("This world’s fundamental problem is that we don’t understand who we truly are—"), _c('span', {
    attrs: {
      "id": "page_p0010-01-0_8_children"
    }
  }, [_vm._v("children of God")]), _vm._v(" made in his image—and instead define ourselves by any number of things other than Jesus. Only by knowing our false identity apart from Christ in relation to our "), _c('i', [_vm._v("true")]), _vm._v(" identity in him can we rightly deal with and overcome the issues in our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0010-04-9"
    }
  }, [_vm._v("My hope is that, by the grace of God, truth of Scripture, and power "), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v(" of the Holy Spirit, this book will help you know your identity in Christ so you can live as you should.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-02-2"
    }
  }, [_vm._v("You aren’t what’s been done to you but what Jesus has done for you. You aren’t what you do but what Jesus has done. What you do doesn’t determine who you are. Rather, who you are in Christ determines what you do. These are fundamental truths that we’ll explore in depth throughout this book.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0011-03-5"
    }
  }, [_vm._v("I’M A CREATED IMAGE BEARER")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-04-6"
    }
  }, [_vm._v("Who do you think you are? Where do we even start to answer that enormous question? Let’s start at the beginning. You are an image bearer of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-8"
    }
  }, [_vm._v("Genesis 1:26–27 says, “Then God said, ‘Let Us make man in Our image, according to Our likeness; let them have dominion over the fish of the sea, over the birds of the air, and over the cattle, over all the earth and over every creeping thing that creeps on the earth.’ So God created man in His own image; in the "), _c('span', {
    attrs: {
      "id": "page_p0011-02-2_51_image"
    }
  }, [_vm._v("image of God")]), _vm._v(" He created him; male and female He created them.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("The trinitarian God who lives in eternal friendship and "), _c('span', {
    attrs: {
      "id": "page_p0011-02-2_33_community"
    }
  }, [_vm._v("community")]), _vm._v(" created us to image him. God uniquely honors humanity in this way. He’s made nothing else in his image. Practically, this means that God made us to image, or reflect, him, as a mirror does. And in a world where we’re encouraged to spend much time gazing at ourselves in a mirror, it’s helpful every time we look in the mirror to be reminded that we’re to mirror God to others. He created us to reflect his goodness and glory in the world around us, like Moses, who radiated the glory of God after being in God’s presence.")]), _c('a', {
    attrs: {
      "href": "#/#p0011-09-14",
      "id": "p0011-Anch1s"
    }
  }, [_c('sup', [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0011-06-11"
    }
  }, [_vm._v("All the Wrong Places")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-07-12"
    }
  }, [_vm._v("The question of identity is one with which humans have struggled since the very beginning of creation. Only by seeing ourselves rightly and "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" biblically "), _c('i', [_vm._v("between")]), _vm._v(" God and the animals can we have both humility and dignity. There alone are we as God intended us to be. By understanding our position "), _c('i', [_vm._v("under")]), _vm._v(" God as created beings, we should remain humble toward and dependent upon God. By understanding our position of dominion "), _c('i', [_vm._v("over")]), _vm._v(" creation, we embrace our dignity as morally superior to animals and expect more from others and ourselves as God’s image bearers.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-2"
    }
  }, [_vm._v("You were created by God, are on the earth to image and glorify God, and when you die, if you are in Christ, you will be with God forever, imaging and glorifying him perfectly in a sinless state.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0012-03-4"
    }
  }, [_vm._v("Ways We Image God")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-04-5"
    }
  }, [_vm._v("Imaging God involves thinking with our heads, feeling with our hearts, and doing with our hands. We’re to think God’s thoughts and agree with his truth as revealed in Scripture. We’re to feel God’s feelings, such as hating injustice and oppression, loving people, grieving sin’s devastating effects, and rejoicing in redemption. We’re to join God’s work using our hands to serve others—Christian and non—with acts of compassion and generosity. When we reflect something of God with our heads, hearts, and hands out of love for him and others, we do what we were created for. This is joyful for us, helpful for others, and worshipful toward God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-04-6"
    }
  }, [_vm._v("As image bearers of a trinitarian God, we’re also made for friendship, community, and conversation. Much of what God designed us to do must be accomplished in and through community. This is why in Genesis 2:18, God said it was “not good” for us to be alone even though sin had not yet entered the world, and why he made another human so our first father, Adam, would have our first mother, Eve, with whom to image God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-04-7"
    }
  }, [_vm._v("When God created "), _c('span', {
    attrs: {
      "id": "page_p0012-02-2_7_adam"
    }
  }, [_vm._v("Adam and Eve")]), _vm._v(", he spoke to them, explaining that they were free to enjoy all of his creation with only one exception—the Tree of the Knowledge of Good and Evil. God spoke to them not because they were sinners—the Fall had not yet happened—but rather because they were human. As humans, and even more so now as sinful humans, we need to hear from God so we can know who we are and subsequently what we should do and not do.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("God’s enemy and our adversary tempted our first parents to "), _c('span', {
    attrs: {
      "id": "page_p0013-01-0_23_sin"
    }
  }, [_vm._v("sin")]), _vm._v(" by creating an "), _c('i', [_vm._v("identity crisis")]), _vm._v(". The father of lies implied that their eyes were closed to their true identity and that their “eyes [would] be opened, and [they would] be like God.” Tragically, the Bible then records the dark, devastating, damning, destructive day when sin entered the world.")]), _c('a', {
    attrs: {
      "href": "#/#p0013-07-8",
      "id": "p0013-Anch3s"
    }
  }, [_c('sup', [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_vm._v("Here is the truth: God made us with our eyes open in his “likeness,” which is our true identity. But Satan and people like him, with the same sinful motives (much like Leonard’s friends in "), _c('i', [_vm._v("Memento")]), _vm._v("), lie to us about who we are in order to serve their "), _c('i', [_vm._v("own")]), _vm._v(" plans. And here is the lie: we will be “like” God if we’ll base our identity upon someone or something else other than God and the grace God bestows upon us."), _c('span', {
    attrs: {
      "href": "#/chapter19#en2",
      "id": "ne2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Adam and Eve fell for it. Rather than simply believing that they were already “like God” because God made them in his “likeness,” our first parents disbelieved their God-given identity and instead sought to create their own apart from him. The result was the first sin and the Fall. We humans have had an identity crisis ever since, seeking to construct an identity ourselves while forgetting about the one God has already given us.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0013-03-3"
    }
  }, [_vm._v("I’m a Worshipper")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-4"
    }
  }, [_vm._v("God created us as worshippers, and worship, rightly understood, begins with the doctrine of the "), _c('span', {
    attrs: {
      "id": "page_p0013-01-0_13_trinity"
    }
  }, [_vm._v("Trinity")]), _vm._v(" and the doctrine of Image. In his magnificent book on worship, Harold Best describes the Trinity as the uniquely Continuous Outpourer who continually pours himself out between the persons of the Godhead in unceasing communication, love, friendship, and joy."), _c('span', {
    attrs: {
      "href": "#/chapter19#en3",
      "id": "ne3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" We, then, created in God’s image, are also unceasing worshippers and continuous outpourers. Best says:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0013-05-6"
    }
  }, [_vm._v("We were created continuously outpouring. Note that I did not say we were created "), _c('i', [_vm._v("to be")]), _vm._v(" continuous outpourers. Nor can I dare imply that we were created "), _c('i', [_vm._v("to")]), _vm._v(" worship. This would suggest that God is an incomplete person whose need for something outside himself (worship) completes his sense of himself. It might not even be safe to say that we were "), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("created "), _c('i', [_vm._v("for")]), _vm._v(" worship, because the inference can be drawn that worship is a capacity that can be separated out and eventually relegated to one of several categories of being. I believe it is strategically important, therefore, to say that we were created continuously outpouring—we were created in that condition, at that instant, "), _c('i', [_vm._v("imago Dei")]), _vm._v(" [image of God].")]), _c('span', {
    attrs: {
      "href": "#/chapter19#en4",
      "id": "ne4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-1"
    }
  }, [_vm._v("Worship is not merely an aspect of our being but the essence of our being. Best synthesizes his thoughts on worship by saying, “I have worked out a definition for worship that I believe covers every possible human condition. It is this: "), _c('i', [_vm._v("Worship is the continuous outpouring of all that I am, all that I do and all that I can ever become in light of a chosen or choosing god")]), _vm._v(".”"), _c('span', {
    attrs: {
      "href": "#/chapter19#en5",
      "id": "ne5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-P-1"
    }
  }, [_vm._v("Our worship never starts and stops. It’s not limited to a building in which we attend sacred meetings and sing worship songs. Rather, our entire life is devoted to pouring ourselves into someone or something. Saying it another way, we’re “unceasing worshippers.”"), _c('span', {
    attrs: {
      "href": "#/chapter19#en6",
      "id": "ne6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" We aren’t created "), _c('i', [_vm._v("to worship")]), _vm._v(", but rather we’re created "), _c('i', [_vm._v("worshipping")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_vm._v("Everything in life is sacred, and nothing is secular. It’s a lie from Satan that life can be compartmentalized in such a way. Everyone—from atheists to Christians—worships unceasingly. In the eyes of God, our choices, values, expenditures, words, actions, and thoughts are all acts of worship. They make up our identity. The only question is, what is your object of worship?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-4"
    }
  }, [_vm._v("All of humanity can be divided into two categories: those who worship the Creator and those who worship created things. Because of sin, we’re prone to worship anyone and anything other than the God who made everyone and everything. That is idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-5"
    }
  }, [_vm._v("Idolatry is when we make a created thing a god thing, which is a bad thing. Idolatry is so destructive and pervasive that biblical counselor David Powlison has rightly said, “Idolatry is by far the most frequently discussed problem in the Scriptures.”"), _c('span', {
    attrs: {
      "href": "#/chapter19#en7",
      "id": "ne7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-P-2"
    }
  }, [_vm._v("Whatever we base our identity and value on becomes “deified.” Our deified object of worship then determines what we glorify and live for. If our object of worship is anything other than God, we’re idolaters worshipping created things, including the fallen angels whom God created."), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" This is precisely what Paul was getting at in Romans 1:25, which speaks of idolaters “who exchanged the truth of God for the lie, and worshiped and served the creature rather than the Creator, who is blessed forever. Amen.” To put it simply, underlying our sinful false worship is the fact that our identity has become rooted in our idolatry. Therefore, it’s vital that we learn to know our "), _c('i', [_vm._v("identity idolatry")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_p0015-03-3_41_identity"
    }
  }, [_vm._v("IDENTITY IDOLATRY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-03-3"
    }
  }, [_vm._v("To help you understand idols, think of them in terms of "), _c('b', [_vm._v("I")]), _vm._v("tems, "), _c('b', [_vm._v("D")]), _vm._v("uties, "), _c('b', [_vm._v("O")]), _vm._v("thers, "), _c('b', [_vm._v("L")]), _vm._v("ongings, and "), _c('b', [_vm._v("S")]), _vm._v("ufferings.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0015-04-5"
    }
  }, [_vm._v("I – Items")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-6"
    }
  }, [_vm._v("What we own is our public way of projecting our desired image. The examples are endless and include such things as our vehicles, wardrobes, technologies, homes, jewelry, furniture, and more. "), _c('span', {
    attrs: {
      "id": "page_p0015-03-3_43_consumerism"
    }
  }, [_vm._v("Consumerism")]), _vm._v(" is now essentially the American religion. Consumer culture is so pervasive that we take it for granted, and almost no aspect of life is untouched by it. Everywhere we turn, we run into advertising telling us to buy things we don’t need, with money we don’t have, to impress people we don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-8"
    }
  }, [_vm._v("There are three main characteristics of the phenomenon of consumerism in America today. First, consumerism isn’t just a "), _c('i', [_vm._v("behavior")]), _vm._v(" but is, in Christian terms, a worldview that tells us who we are. If possessions define your identity, then the brand name on your clothes and the maker of your car are vital.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Second, consumerism is often driven by the desire to gain "), _c('span', {
    attrs: {
      "id": "page_p0015-03-3_33_status"
    }
  }, [_vm._v("status")]), _vm._v(" and prestige with one’s peers. Sociologist Thorstein Veblen, who coined the phrase “"), _c('span', {
    attrs: {
      "id": "page_p0015-03-3_42_conspicuous"
    }
  }, [_vm._v("conspicuous consumption")]), _vm._v(",” articulated this idea at the turn of the last century. Veblen argued that the chief way we obtain "), _c('span', {
    attrs: {
      "id": "page_p0015-03-3_46_social"
    }
  }, [_vm._v("social prestige")]), _vm._v(" and power is through conspicuous displays of leisure and consumption.")]), _c('span', {
    attrs: {
      "href": "#/chapter19#en8",
      "id": "ne8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Social prestige is connected to wealth, and we demonstrate our wealth by flaunting it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-10"
    }
  }, [_vm._v("Today, with television tours of the world’s wealthiest people’s homes, we no longer compare our possessions to those of the generations before "), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v(" us or our neighbors but rather to the elite’s. The results are coveting, overspending, and debt fueled by advertising. Some sociologists call this “competitive consumption,” which forces average people and families to work harder, spend less time with those they love, and live more miserably enslaved to debt in an ongoing effort to prop up some false sense of identity and personal value.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_vm._v("Third, products are not simply valued for their usefulness but rather play a central role in the cultivation and maintenance of our identity. This is a powerful explanation for why consumer goods are so much more than objects we use; they are things for which we will fight and sometimes even kill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-4"
    }
  }, [_vm._v("The point is that in today’s consumer culture, our goods are carriers of meaning. They define us, send social signals to others, and construct our identities. Subsequently, wearing non-designer clothes, driving an old car, and using anything but the latest technology somehow devalues us as human beings. Put bluntly, when consumerism is your religion and stuff the object of your worship, “the things you own end up owning you,” to quote Tyler Durden from the movie "), _c('i', [_vm._v("Fight Club")]), _vm._v("(1999).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-5"
    }
  }, [_vm._v("The problem is not in the mall but rather in us. It’s not a sin to purchase items or even to appreciate and enjoy them. But when those things become the source of our identity, we become guilty of idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0016-03-7"
    }
  }, [_vm._v("D – Duties")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-8"
    }
  }, [_vm._v("Life is filled with duties, starting with chores when we are young, then homework in school, job requirements in the workforce, ministry obligations in the church, relational duties in marriage, and parental and grandparental duties in our families. Our duties can rightly be a way we worship God or wrongly be a god we worship.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("If you find your identity in the achievement of your duties, you’ll have many troubles. First, you’ll always search for something to excel at in an effort to outperform others and demonstrate your superiority. Once you believe you’ve found that “thing,” you’ll become overly committed and possibly even obsessed with mastering it. Other people and things (like your health) will no longer matter much to you and will instead be placed ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" on the altar of success to the god of achievement. Soon you’ll become so competitive that winning is all that matters. The more you win, the less compassion you have for others. In time, this will turn into disdain for those who are hurting, struggling, or failing. As you succeed, you will become proud and unpleasant to be around, with all your boasting about your accomplishments—even if it’s only by subtly moving conversations toward you and your achievements while fishing for compliments. When you fail or lose, you become depressed, panicked, and devastated, which makes you both miserable and miserable to be around.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_vm._v("The truth is that you’re not what you do. You have God-given natural talents, Holy Spirit–endowed gifts, and unique abilities. You also have duties, but these duties do not define you, because your identity is not determined by what you do. Rather, who you are in Christ helps you faithfully pursue your duties and use your abilities without them becoming the essence of your dignity and identity.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0017-03-4"
    }
  }, [_vm._v("O – Others")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-5"
    }
  }, [_vm._v("God made us for friendship and community. It’s good to have others in our lives. But like all things, this good thing can become a god thing if others become the source of our identity. This happens broadly in our identification with a collective "), _c('i', [_c('span', {
    attrs: {
      "id": "page_p0017-02-2_12_tribe"
    }
  }, [_vm._v("tribe")])]), _vm._v(" of people, and narrowly in our "), _c('i', [_vm._v("individual")]), _vm._v(" relationships with others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-6"
    }
  }, [_vm._v("Your tribe is the greater community with which you most closely identify. Its members can include not only your family, but also people from your city, school, class, and sports team. Your tribe can also include those having the same nationality, race, gender, ethnicity, culture, income level, hobby, political party, theological affinity, sexual orientation, and more. While it is good to have community, we often turn this good thing into a bad thing by basing our identity on and idolizing our tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-7"
    }
  }, [_vm._v("If you idolize your tribe, you will also demonize other tribes. This explains why there is often unnecessary and unholy hostility between nations, cities, genders, races, schools, classes, cultures, sports fans, churches, political parties, educational systems (e.g., private, public, homeschool), and even Christian denominations.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("More narrowly speaking, if others form our identity, then our personal relationships become unhealthy. This propensity to find our identity in others is commonly referred to as giving in to "), _c('span', {
    attrs: {
      "id": "page_p0018-01-0_40_peer"
    }
  }, [_vm._v("peer pressure")]), _vm._v(", people pleasing, codependency, and having a fear of man. Practically, this explains why we’ll often change our appearance and behavior depending on whom we’re with and whom we seek to impress.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-1"
    }
  }, [_vm._v("Obtaining an identity from our relationships can manifest itself in the idols of independence or dependence. With the idol of independence, we rightly fear allowing our identity to be determined by others. Unfortunately, in the midst of our right fear, we wrongly avoid close relationships because we don’t want to risk being emotionally hurt—which means others still control our identity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-3"
    }
  }, [_vm._v("Conversely, those of us who serve the idol of dependence simply cannot be alone. We have to be in some sort of deep friendship if single, or place unrealistic expectations on our partners if married or dating. We cannot bear the thought of being alone. While this may look loving, when we struggle with an idol of dependence, we’re in fact not loving people as much as we’re using them to fulfill our need to belong, be liked, and be desired.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-4"
    }
  }, [_vm._v("This explains why some friends and family members can be so demanding, smothering, and needy. It also explains why we’re so easily inflated by praise and deflated by criticism. It’s as if others have the ability to determine our identity for that day based on a word or even a glance. In giving this power over our lives to others, we give them a godlike position to rule over us and define who we are. And in the age of technology, when folks can wield this power publicly for others to witness online, a low-level, constant anxiety slowly robs us of peace and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0018-02-6"
    }
  }, [_vm._v("L – Longings")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-7"
    }
  }, [_vm._v("Longings give us hope that tomorrow might be better so we can persevere today. We all have longings, but when they become the source of our identity, our life becomes inordinately governed by our feelings and our future rather than our present, and God’s past, present, and future work on our behalf.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Our longings can cause our identity to shift like an airborne balloon, ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" pushed by every breeze. On days when we’re healthy, receive good news, or achieve something, we feel powerful and hopeful. On days when we’re sick, hear bad news, or fail, we feel powerless and hopeless. This causes some people to live emotionally volatile lives with towering highs as their identity soars, and defeating lows as their identity crashes.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-2"
    }
  }, [_vm._v("Living for the future causes one’s identity to always be out there, tomorrow, just around the corner, rather than a present reality secured by Jesus and his work on the cross. We live for the future, hanging all our "), _c('span', {
    attrs: {
      "id": "page_p0019-02-2_18_hope"
    }
  }, [_vm._v("hope")]), _vm._v("s on grabbing the proverbial carrot dangling in front of us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-3"
    }
  }, [_vm._v("Often, identity idolatry rooted in longing is mistaken for good and necessary biblical hope. The Bible talks a lot about hope because it’s the result of faith in God. If we truly believe that God is alive, good, and at work in our lives, that changes our attitudes and actions. Hope helps us get out of bed in the morning, seek the Lord in prayer, and face whatever the day may bring. But sometimes we use hope in a sinful way, convinced that our desired identity will come in the future rather than living in the identity that is already a present reality.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-4"
    }
  }, [_vm._v("People who base their identity in the future are often religiously devout, sincere, optimistic, and like to talk about faith and trusting the Lord. They are often also prone to sounding pious and quoting out-of-context Bible verses about Christians being victorious, complete with pithy statements such as, “When God closes a door, he always opens a window,” or, “God must have something even better in store.” Their identity is found in such things as getting physical healing, getting married, having children, fulfilling vocational ministry, achieving financial security, reaching the next season of life, and so forth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-5"
    }
  }, [_vm._v("While it’s not a sin to plan and strive for a better tomorrow, it is a sin to set one’s joy and identity on who we will be, what we will do, or what we will have tomorrow in our own efforts rather than on Christ today and who he will make us, what he will have us do, and what he will give to us tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "ctc1",
    attrs: {
      "id": "p0019-03-7"
    }
  }, [_vm._v("S – Sufferings")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-04-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("As long as we’re alive, we’ll suffer. We suffer physically. We suffer ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" emotionally as we hurt others and they hurt us. We suffer financially, each of us struggling to get by and to find or keep a good job. We suffer mentally with everything from the overwhelming responsibilities of life to the name-calling bullying and criticism that are dished out in large portions every day. We suffer relationally as friends betray us, children ignore us, and spouses leave us. We suffer spiritually as, in the midst of our distress, it sometimes seems as if God is busy, far away, and uninterested.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-2"
    }
  }, [_vm._v("When we suffer, we can easily allow our hurt to become our identity. Our pain can become all-consuming and overwhelming. Admittedly, it’s hard to tell a cancer patient, divorcee, or rape victim that his or her pain isn’t the defining aspect of who that individual is. But if we truly love those who suffer, we must humbly, graciously, and patiently explain that to be a Christian is not to live a life free from suffering, but rather, suffering should lead us to identify with Jesus, who suffered more than anyone in history on our behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-4"
    }
  }, [_vm._v("Tina knows this only too well. She was diagnosed some years ago with brain cancer. Two weeks later, she had surgery to have the tumor removed. She thought it would be a quick recovery and she’d be back to normal. But she soon realized that life would be very different for her from that point on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-5"
    }
  }, [_vm._v("The tumor had eaten away at her skull, pushing through it and causing a bump on her head (the primary symptom that led to diagnosis). As a result, the neurosurgeon had to remove that portion of her skull and cover the hole with titanium plates and screws. Since then, she’s dealt with constant headaches, and the daily, chronic pain is a continual reminder of her brain tumor. She also suffered from other side effects that continue to the present day, including changes in how she responds to people, how she processes certain kinds of information, and more.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Making matters worse, six months after her surgery, in hopes of recovering and “getting back to normal,” she quit her job and moved in with her parents. Instead of finding a loving and healthy environment in which to heal, she ended up dealing with significant problems her parents were facing on top of her own problems—putting her recovery on hold. As she puts it, “My life became about day-to-day survival, as I was ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v(" trapped in that whole situation because I had no money and wasn’t able to work to get any so I could leave. The turmoil and darkness continued for years.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-2"
    }
  }, [_vm._v("By God’s grace, Tina finally won a disability claim, someone stepped in to take care of her parents, and she was free to move out on her own again. She relates, “It took about a year and a half of being in a safe and normal environment, where there’s steady week-in, week-out preaching, teaching, and singing about Jesus, not to mention interaction with other Christians (I had been isolated for a very long time) and quiet seed-planting by the Holy Spirit, before I was able to recognize that I had based my primary identity on being a brain-tumor survivor. I wasn’t a Christian who’d had a brain tumor. I was a brain-tumor survivor who was also a Christian.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-P-1"
    }
  }, [_vm._v("This realization helped Tina move from defining her identity as a brain-cancer survivor to seeing herself as a beloved daughter of God with a big brother in Jesus, who suffered for her so she wouldn’t have to be defined by her suffering. She realized that while being a brain-tumor survivor, with the limitations and scars that resulted, is an important part of her life, it’s not her identity. “They may help explain me,” she says, “but they don’t define me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-4"
    }
  }, [_vm._v("This is not to say life is easy. “Where I’m at right now is trying to take what I know, which is that my identity is in/through/because of Jesus, and applying it to my life. That old identity was entrenched in me for so long, I know it will take a while for old ways to be gone and new ways to come,” she says. “I know that, for the first time since it all happened, this year I was able to acknowledge my anniversary of my diagnosis and surgery with celebration that I’m alive instead of the mourning of years past. I know that the name of Jesus has proceeded from my mouth (in conversation) and my hands (in my writing) more than it ever has before. I know that, even though there are still days of struggle and falling back into that mentality, I finally have hope that I just might have a future after all, not just any future, but one worth having. And I know that I want to know more about grace.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("How about you? How has your worst day, greatest suffering, or deepest loss so marked your life that it has become your identity? How can ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" you, like Tina, move from your pain and suffering defining you to Jesus defining you? It won’t be easy, but it is necessary.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0022-02-2"
    }
  }, [_vm._v("IDENTITY CRISIS")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0022-03-3"
    }
  }, [_vm._v("Most of us live unaware of the source of our identity until change occurs, often in the form of hardships and pain. When an individual faces adversity, it leads to a crisis as his marriage, children, appearance, wealth, success, career, religious performance, political party, favorite cause, loving relationship, treasured possession, or something else crumbles under the weight of being a god. Suddenly he realizes that the source of his identity was the idolatry of that treasured thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-5"
    }
  }, [_vm._v("Once he senses this identity crisis emotionally, even if he lacks the words for it theologically, a pattern of crisis management sets in. First, he lives in anxiety and fear that the source of his identity may fail him or be taken from him. Then, as his identity begins to totter, he becomes panicked and seeks to salvage his identity idol. Finally, when his identity fails him, he looks for someone to "), _c('span', {
    attrs: {
      "id": "page_p0022-03-3_0_blame"
    }
  }, [_vm._v("blame")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-6"
    }
  }, [_vm._v("Blame takes many forms. Some people blame God for taking their idol away and become bitter toward him. Some blame other people and become resentful, angry, and even violent against those whom they blame. Still others blame themselves and feel like failures, hating themselves for it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-8"
    }
  }, [_vm._v("Tragically, many who lose their individual identity idol simply choose another one, rather than turning to Jesus Christ. Consequently, they repeat the entire painful process over and over in their lives. Such people go from one addiction and compulsion to another, one religious commitment to another, and one relationship to another, continually seeking the answer to the question, “Who am I?” Meanwhile, they never find the only true answer to their identity crisis—Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-9"
    }
  }, [_vm._v("The rest of this book is dedicated to helping you discover the power and joy that is found only in an identity founded and sustained in and by Jesus. My prayer is that you’ll find the answer to “Who am I?” in Christ, who is the I AM.")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  })]), _c('p', {
    staticClass: "fn",
    attrs: {
      "id": "p0011-09-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#p0011-Anch1s",
      "id": "p0011-Anch2e"
    }
  }, [_vm._v("a")]), _vm._v(". Ex. 34:30.")]), _vm._v(" "), _c('p', {
    staticClass: "fn",
    attrs: {
      "id": "p0013-07-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#p0013-Anch3s",
      "id": "p0013-Anch4e"
    }
  }, [_vm._v("b")]), _vm._v(". Gen. 3.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0